import { reactive } from '@vue/composition-api'

export default defineNuxtPlugin((nuxtApp) => {
  const app = nuxtApp.vueApp
  app.config.globalProperties.$toastItems = reactive([])
  const addToast = ({ title, description, variant, buttons, time }) => {
    app.config.globalProperties.$toastItems.push({
      title,
      description,
      variant,
      buttons,
      time,
    })
  }

  const addErrorToast = (description) => {
    app.config.globalProperties.$toastItems.push({
      title: 'Error',
      description,
      variant: 'danger',
      time: 5000,
    })
  }

  const addSuccessToast = (description) => {
    app.config.globalProperties.$toastItems.push({
      title: 'Success',
      description,
      variant: 'success',
      time: 5000,
    })
  }

  app.provide('toast', {
    show: addToast,
    error: addErrorToast,
    success: addSuccessToast,
  })

  app.config.globalProperties.$toast = addToast
  app.config.globalProperties.$toastError = addErrorToast
  app.config.globalProperties.$toastSuccess = addSuccessToast
})
